import NotificationsDrawer from './NotificationsDrawer';

export default NotificationsDrawer;
